import { PaymentConfiguration } from 'types';

export const getAdditionalLessonPriceText = (
    price: number,
    paymentType: PaymentConfiguration,
) => `${price}
${paymentType === PaymentConfiguration.EACH_LESSON ? 'zł' : 'zł/msc'}`;
